import SEO from '@/components/seo'
import Privacy from '@/views/privacy'

const PrivacyPage = () => (
  <>
    <SEO
      title="プライバシーポリシー"
      url="privacy"
      description="ONLIVE Studio のプライバシーポリシーです。お客様の個人情報の取り扱いについて定めています。"
    />
    <Privacy />
  </>
)

export default PrivacyPage
